import { render, staticRenderFns } from "./SelectWorkFlowSchemeDlg.vue?vue&type=template&id=4a54a22b"
import script from "./SelectWorkFlowSchemeDlg.vue?vue&type=script&lang=js"
export * from "./SelectWorkFlowSchemeDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports